import { createAction } from 'redux-actions';
import { NotificationType } from './types';
import { makeNotification } from './makeNotification';
import { actionKey } from './constants';
import { NotificationDuration } from '../Notification';
export const addNotificationToQueue = createAction(`${actionKey}.ADD`, (queueName, type, params)=>({
        notification: makeNotification(type, queueName, params),
        queueName
    }));
export const addNotification = (type, params)=>addNotificationToQueue('default', type, params);
export const removeNotificationFromQueue = createAction(`${actionKey}.REMOVE`, (queueName, id)=>({
        id,
        queueName
    }));
export const removeNotification = (id)=>removeNotificationFromQueue('default', id);
export const removeQueues = createAction(`${actionKey}.REMOVE_QUEUES`, (predicate)=>({
        predicate
    }));
export const addErrorNotification = (message, duration = NotificationDuration.XL)=>addNotification(NotificationType.Generic, {
        message,
        isError: true,
        cardProps: {
            withShadow: true,
            multiLine: true,
            duration
        }
    });
export const genericUndoAction = createAction(`${actionKey}.UNDO`, ()=>({}));
